import * as React from "react"

const FeatureHeroBenefits = ({ title, items }) => {
  return (
    <div className="feature-hero__benefits shadow-lg">
      <p className="p--lg">{title}</p>
      <ul className="feature-checklist feature-checklist--dark">
        {items.map(item => (
          <li className="feature-checklist__item" key={item}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default FeatureHeroBenefits
